import React from 'react';
import {useIsAuthenticated} from '../../features/Authentication/hooks/useIsAuthenticated';
import {SubscribeToWhatsappNewsletter as SubscribeToWhatsappNewsletterBase} from './SubscribeToWhatsappNewsletter.eager';
import {useWhatsappParams} from './hooks/useSubscribeToWhatsappNewsletter';

export const SubscribeToWhatsappNewsletter = () => {
  const {whatsappUUIDToken, countryCode} = useWhatsappParams();
  const {isAuthenticated, isUserDataLoading} = useIsAuthenticated();

  if (!whatsappUUIDToken || (!isAuthenticated && isUserDataLoading)) {
    return null;
  }

  return (
    <SubscribeToWhatsappNewsletterBase
      whatsappUUIDToken={whatsappUUIDToken}
      countryCode={countryCode || ''}
    />
  );
};
